import Index from './Index.vue';
import SettingsContent from '../Wrapper.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import WhatsAppMessageTracks from '../../../../components/WhatsAppMessageTracks.vue';
import SmartAiEmailCampaignContacts from './SmartAiEmailCampaignContacts.vue';
import EmailMessageTracks from '../../../../components/EmailMessageTracks.vue';

/** Single parent route so matched child determines header (avoids wrong props when duplicate paths existed). */
function campaignSettingsProps(route) {
  const { name, path } = route;
  const byName = {
    settings_account_campaigns: {
      headerTitle: 'CAMPAIGN.ONGOING.HEADER',
      icon: 'arrow-swap',
    },
    one_off: { headerTitle: 'CAMPAIGN.ONE_OFF.HEADER', icon: 'sound-source' },
    whatsapp_campaigns: {
      headerTitle: 'CAMPAIGN.WHATSAPP.HEADER',
      icon: 'whatsapp',
    },
    whatsapp_campaigns_messages: {
      headerTitle: 'CAMPAIGN.WHATSAPP.HEADER',
      icon: 'whatsapp',
    },
    smart_ai_email_campaign: {
      headerTitle: 'CAMPAIGN.SMART_AI_EMAIL.HEADER',
      icon: 'mail',
    },
    smart_ai_email_campaign_contacts: {
      headerTitle: 'CAMPAIGN.SMART_AI_EMAIL.HEADER',
      icon: 'mail',
    },
    email_campaigns: { headerTitle: 'CAMPAIGN.EMAIL.HEADER', icon: 'mail' },
    email_campaigns_messages: {
      headerTitle: 'CAMPAIGN.EMAIL.HEADER',
      icon: 'mail',
    },
  };
  if (name && byName[name]) {
    return byName[name];
  }
  if (path.includes('/email_messages') || path.endsWith('/email_campaigns')) {
    return { headerTitle: 'CAMPAIGN.EMAIL.HEADER', icon: 'mail' };
  }
  if (
    path.includes('/whatsapp_messages') ||
    path.endsWith('/whatsapp_campaigns')
  ) {
    return { headerTitle: 'CAMPAIGN.WHATSAPP.HEADER', icon: 'whatsapp' };
  }
  if (path.includes('/smart_ai_email_campaign')) {
    return { headerTitle: 'CAMPAIGN.SMART_AI_EMAIL.HEADER', icon: 'mail' };
  }
  if (path.includes('/one_off')) {
    return { headerTitle: 'CAMPAIGN.ONE_OFF.HEADER', icon: 'sound-source' };
  }
  if (path.includes('/ongoing')) {
    return { headerTitle: 'CAMPAIGN.ONGOING.HEADER', icon: 'arrow-swap' };
  }
  return { headerTitle: 'CAMPAIGN.WHATSAPP.HEADER', icon: 'whatsapp' };
}

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: campaignSettingsProps,
      children: [
        {
          path: '',
          redirect: { name: 'whatsapp_campaigns' },
        },
        {
          path: 'ongoing',
          name: 'settings_account_campaigns',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'one_off',
          name: 'one_off',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'whatsapp_campaigns',
          name: 'whatsapp_campaigns',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'whatsapp_campaigns/:campaigns_id/whatsapp_messages',
          name: 'whatsapp_campaigns_messages',
          roles: ['administrator'],
          component: { ...WhatsAppMessageTracks },
        },
        {
          path: 'smart_ai_email_campaign',
          name: 'smart_ai_email_campaign',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'smart_ai_email_campaign/:campaigns_id/contacts',
          name: 'smart_ai_email_campaign_contacts',
          roles: ['administrator'],
          component: SmartAiEmailCampaignContacts,
        },
        {
          path: 'email_campaigns',
          name: 'email_campaigns',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'email_campaigns/:campaigns_id/email_messages',
          name: 'email_campaigns_messages',
          roles: ['administrator'],
          component: { ...EmailMessageTracks },
        },
      ],
    },
  ],
};
